var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: true, "max-width": "790", width: "530", persistent: "" }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-box" },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("PleaseSelectWorkspaceOpen")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pl-6" },
            [
              _c("treeselect", {
                staticStyle: { "margin-bottom": "10px" },
                attrs: { options: _vm.workspaceOptions },
                on: { input: _vm.updateWorkspaceSelected }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "pa-0 pt-2" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button select-workspace-button",
                  attrs: { ripple: false },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "black" } }, [
                    _vm._v(_vm._s(_vm.$t("Exit")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button select-workspace-button",
                  attrs: {
                    ripple: false,
                    color: "white--text",
                    disabled: !_vm.workspaceSelected
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit(
                        "confirm",
                        _vm.workspaceSelected,
                        _vm.newTab
                      )
                    }
                  }
                },
                [
                  _c("span", { staticClass: "select-workspace-button-text" }, [
                    _vm._v(_vm._s(_vm.$t("Confirm")))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef5ce1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef5ce1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Content/SelectWorkspaceDialogBox.vue
// module id = null
// module chunks = 